import ReactTooltip from 'react-tooltip';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { sortByNameInAlphabeticalOrder } from '@utils/miscellaneous/sortings';

// components

import Table from '@common-components/table/Table';

const StyledTableContainer = styled.div`
   th {
    &:first-child {
      padding-left: 10px;
    }
  }
`;

const CustomFieldList = props => {
    
    const {
        customFields,
        getCustomField
    } = props;

    const handleClick = (e,customField) => {
        e.preventDefault();
        getCustomField(customField.id);
    };
    const columns  = [
        {
            id: 'name',
            text: 'Name'
        },
        {
            id: 'type',
            text: 'Type'
        },
        {
            id: 'description',
            text: 'Tool Tip'
        },
        {
            id: 'workflowsCount',
            text: 'Utilization'
        }
    ];

    const FIELD_DESCRIPTION_DISPLAY_LENGTH = 50;

    const truncateString = (str: string = '', maxLength: number) => {
        return str.length > maxLength ? `${str.slice(0, maxLength)}…` : str;
    };

    const processTableDataFetch = (data) => {
        if (data && data.length > 0) {
            return data.map((row) => {
                const typeColumn = !row.optionValues ? row.type : (row.type + ' (  ' + Object.keys(row.optionValues).map(key => `${row.optionValues[key]}`).join(', '))+ ' )';
                return {
                    name: <a data-tip data-for={`tooltip_custom_field_name_${row.id}`} href="#" onClick={(e) => handleClick(e,row)}>
                        {row.name}
                        {row.name && row.name.length > 0 && 
                        <ReactTooltip 
                            place="left"
                            type="dark"
                            effect="solid"
                            id={`tooltip_custom_field_name_${row.id}`}>
                            {row.name}
                        </ReactTooltip>
                        }</a>,
                    description: <span data-tip data-for={`tooltip_custom_field_description_${row.id}`}>
                        {row.description ? truncateString(row.description, FIELD_DESCRIPTION_DISPLAY_LENGTH) : '-'} 
                        {row.description && row.description.length > 0 &&
                            <ReactTooltip
                                place="left"
                                type="dark"
                                effect="solid"
                                multiline={true}
                                id={`tooltip_custom_field_description_${row.id}`}
                            >
                                {row.description ? row.description : '-'}
                            </ReactTooltip>
                        }</span>,
                    type: <span data-tip data-for={`tooltip_custom_field_type_${row.id}`}>
                        {typeColumn}
                        <ReactTooltip
                            place="left"
                            type="dark"
                            effect="solid"
                            multiline={true}
                            id={`tooltip_custom_field_type_${row.id}`}
                        >
                            {typeColumn}
                        </ReactTooltip>
                    </span>,
                    workflowsCount:  <span data-tip data-for={`custom_field_workflows_${row.id}`}>{row.workflowsCount ? row.workflowsCount : 0}
                        {row.workflowsDetailDtoList && row.workflowsDetailDtoList.length > 0 &&
                            <ReactTooltip
                                place="left"
                                type="dark"
                                effect="solid"
                                id={`custom_field_workflows_${row.id}`}
                            >
                                <ul>
                                    {row.workflowsDetailDtoList.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <span>{item.workflowType + ' > ' + item.workflowSubType + '('+ (item.required ? 'r' : 'o') + ')' } </span>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </ReactTooltip>
                        }
                    </span>
                };
            });
        }
    };
    return useMemo(() => {
        const processTableData = processTableDataFetch(sortByNameInAlphabeticalOrder(customFields));
        return (
            <StyledTableContainer className="ticket-types__table">
                {
                    processTableData &&
                    <Table columns={columns} data={processTableData} className='tblCustomFieldList' />
                }
            </StyledTableContainer>
        );
    }, [ customFields ]);
};

export default CustomFieldList;